// Auto-generated from DaisyUI v5 themes — do not edit manually
// Run: npx tsx scripts/convert-daisy-themes.ts > packages/arche-sdk/src/themes/catalog-data.ts

import type { ThemeCatalogEntry } from './index';

export const DAISY_THEMES: ThemeCatalogEntry[] = [
  {
    id: 'abyss',
    name: 'Abyss',
    source: 'daisy' as const,
    mode: 'dark' as const,
    theme: {
      mode: 'dark' as const,
      colors: {
        primary: '#bdff00',
        primaryText: '#427600',
        secondary: '#cebef4',
        accent: '#505050',
        background: '#001e29',
        surface: '#00111d',
        card: '#00111d',
        cardText: '#ffd6a7',
        text: '#ffd6a7',
        textSecondary: '#564775',
        muted: '#003843',
        mutedText: '#ffd6a7',
        border: '#000611',
        error: '#f04e4f',
        warning: '#ffbf00',
        success: '#01df72',
        info: '#00bafe',
      },
      spacing: { xs: '4px', sm: '8px', md: '16px', lg: '24px', xl: '32px' },
      fonts: {
        body: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
        heading: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
        mono: "'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, monospace",
      },
      components: {
        borderRadius: '0.5rem',
        buttonRadius: '2rem',
        cardRadius: '0.5rem',
        inputRadius: '0.25rem',
        shadowSm: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
        shadowMd: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1)',
        shadowLg: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1)',
        borderWidth: '1px',
      },
    },
    preview: {
      colors: ['#bdff00', '#cebef4', '#001e29', '#505050'] as [string, string, string, string],
    },
  },
  {
    id: 'acid',
    name: 'Acid',
    source: 'daisy' as const,
    mode: 'light' as const,
    theme: {
      mode: 'light' as const,
      colors: {
        primary: '#ff00ff',
        primaryText: '#180017',
        secondary: '#ff6e00',
        accent: '#c8ff00',
        background: '#f8f8f8',
        surface: '#eeeeee',
        card: '#eeeeee',
        cardText: '#000000',
        text: '#000000',
        textSecondary: '#180400',
        muted: '#140151',
        mutedText: '#c7cadc',
        border: '#e1e1e1',
        error: '#ff0000',
        warning: '#ffe200',
        success: '#00ff8a',
        info: '#007fff',
      },
      spacing: { xs: '4px', sm: '8px', md: '16px', lg: '24px', xl: '32px' },
      fonts: {
        body: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
        heading: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
        mono: "'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, monospace",
      },
      components: {
        borderRadius: '1rem',
        buttonRadius: '1rem',
        cardRadius: '1rem',
        inputRadius: '1rem',
        shadowSm: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
        shadowMd: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1)',
        shadowLg: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1)',
        borderWidth: '1px',
      },
    },
    preview: {
      colors: ['#ff00ff', '#ff6e00', '#f8f8f8', '#c8ff00'] as [string, string, string, string],
    },
  },
  {
    id: 'aqua',
    name: 'Aqua',
    source: 'daisy' as const,
    mode: 'dark' as const,
    theme: {
      mode: 'dark' as const,
      colors: {
        primary: '#13ecf3',
        primaryText: '#015355',
        secondary: '#966fb3',
        accent: '#ffe999',
        background: '#1a368b',
        surface: '#162455',
        card: '#162455',
        cardText: '#b8e6fe',
        text: '#b8e6fe',
        textSecondary: '#f2f0fc',
        muted: '#05176c',
        mutedText: '#90baff',
        border: '#091444',
        error: '#ff7265',
        warning: '#d97708',
        success: '#18a34a',
        info: '#2563eb',
      },
      spacing: { xs: '4px', sm: '8px', md: '16px', lg: '24px', xl: '32px' },
      fonts: {
        body: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
        heading: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
        mono: "'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, monospace",
      },
      components: {
        borderRadius: '1rem',
        buttonRadius: '1rem',
        cardRadius: '1rem',
        inputRadius: '0.5rem',
        shadowSm: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
        shadowMd: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1)',
        shadowLg: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1)',
        borderWidth: '1px',
      },
    },
    preview: {
      colors: ['#13ecf3', '#966fb3', '#1a368b', '#ffe999'] as [string, string, string, string],
    },
  },
  {
    id: 'autumn',
    name: 'Autumn',
    source: 'daisy' as const,
    mode: 'light' as const,
    theme: {
      mode: 'light' as const,
      colors: {
        primary: '#8c0327',
        primaryText: '#edd0d0',
        secondary: '#d85251',
        accent: '#d59b6b',
        background: '#f1f1f1',
        surface: '#dbdbdb',
        card: '#dbdbdb',
        cardText: '#141414',
        text: '#141414',
        textSecondary: '#110202',
        muted: '#826a5c',
        mutedText: '#e5e0dd',
        border: '#c5c5c5',
        error: '#d40014',
        warning: '#e97f16',
        success: '#499380',
        info: '#44adbb',
      },
      spacing: { xs: '4px', sm: '8px', md: '16px', lg: '24px', xl: '32px' },
      fonts: {
        body: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
        heading: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
        mono: "'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, monospace",
      },
      components: {
        borderRadius: '1rem',
        buttonRadius: '1rem',
        cardRadius: '1rem',
        inputRadius: '0.5rem',
        shadowSm: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
        shadowMd: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1)',
        shadowLg: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1)',
        borderWidth: '1px',
      },
    },
    preview: {
      colors: ['#8c0327', '#d85251', '#f1f1f1', '#d59b6b'] as [string, string, string, string],
    },
  },
  {
    id: 'black',
    name: 'Black',
    source: 'daisy' as const,
    mode: 'dark' as const,
    theme: {
      mode: 'dark' as const,
      colors: {
        primary: '#3a3a3a',
        primaryText: '#ffffff',
        secondary: '#3a3a3a',
        accent: '#3a3a3a',
        background: '#000000',
        surface: '#141414',
        card: '#141414',
        cardText: '#d6d6d6',
        text: '#d6d6d6',
        textSecondary: '#ffffff',
        muted: '#3a3a3a',
        mutedText: '#ffffff',
        border: '#1b1b1b',
        error: '#ff0301',
        warning: '#ffff00',
        success: '#028002',
        info: '#0000ff',
      },
      spacing: { xs: '4px', sm: '8px', md: '16px', lg: '24px', xl: '32px' },
      fonts: {
        body: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
        heading: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
        mono: "'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, monospace",
      },
      components: {
        borderRadius: '0rem',
        buttonRadius: '0rem',
        cardRadius: '0rem',
        inputRadius: '0rem',
        shadowSm: 'none',
        shadowMd: 'none',
        shadowLg: 'none',
        borderWidth: '1px',
      },
    },
    preview: {
      colors: ['#3a3a3a', '#3a3a3a', '#000000', '#3a3a3a'] as [string, string, string, string],
    },
  },
  {
    id: 'bumblebee',
    name: 'Bumblebee',
    source: 'daisy' as const,
    mode: 'light' as const,
    theme: {
      mode: 'light' as const,
      colors: {
        primary: '#fdc700',
        primaryText: '#733e0a',
        secondary: '#ff8904',
        accent: '#000000',
        background: '#ffffff',
        surface: '#f5f5f5',
        card: '#f5f5f5',
        cardText: '#161616',
        text: '#161616',
        textSecondary: '#7c2808',
        muted: '#433f3a',
        mutedText: '#e6e4e3',
        border: '#e4e4e4',
        error: '#ff6266',
        warning: '#fcb700',
        success: '#00d390',
        info: '#00bafe',
      },
      spacing: { xs: '4px', sm: '8px', md: '16px', lg: '24px', xl: '32px' },
      fonts: {
        body: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
        heading: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
        mono: "'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, monospace",
      },
      components: {
        borderRadius: '1rem',
        buttonRadius: '1rem',
        cardRadius: '1rem',
        inputRadius: '0.5rem',
        shadowSm: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
        shadowMd: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1)',
        shadowLg: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1)',
        borderWidth: '1px',
      },
    },
    preview: {
      colors: ['#fdc700', '#ff8904', '#ffffff', '#000000'] as [string, string, string, string],
    },
  },
  {
    id: 'business',
    name: 'Business',
    source: 'daisy' as const,
    mode: 'dark' as const,
    theme: {
      mode: 'dark' as const,
      colors: {
        primary: '#1c4e80',
        primaryText: '#d0dae5',
        secondary: '#7c909a',
        accent: '#ea6947',
        background: '#202020',
        surface: '#1c1c1c',
        card: '#1c1c1c',
        cardText: '#cdcdcd',
        text: '#cdcdcd',
        textSecondary: '#050708',
        muted: '#23282e',
        mutedText: '#cecfd0',
        border: '#181818',
        error: '#ac3e31',
        warning: '#dbae5a',
        success: '#6bb187',
        info: '#0291d5',
      },
      spacing: { xs: '4px', sm: '8px', md: '16px', lg: '24px', xl: '32px' },
      fonts: {
        body: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
        heading: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
        mono: "'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, monospace",
      },
      components: {
        borderRadius: '0.25rem',
        buttonRadius: '0rem',
        cardRadius: '0.25rem',
        inputRadius: '0.25rem',
        shadowSm: 'none',
        shadowMd: 'none',
        shadowLg: 'none',
        borderWidth: '1px',
      },
    },
    preview: {
      colors: ['#1c4e80', '#7c909a', '#202020', '#ea6947'] as [string, string, string, string],
    },
  },
  {
    id: 'caramellatte',
    name: 'Caramellatte',
    source: 'daisy' as const,
    mode: 'light' as const,
    theme: {
      mode: 'light' as const,
      colors: {
        primary: '#000000',
        primaryText: '#ffffff',
        secondary: '#370a00',
        accent: '#8c3f27',
        background: '#fff7ed',
        surface: '#feecd3',
        card: '#feecd3',
        cardText: '#7c2808',
        text: '#7c2808',
        textSecondary: '#ffd6a7',
        muted: '#c93400',
        mutedText: '#fff7ed',
        border: '#ffd6a7',
        error: '#ff6266',
        warning: '#fcb700',
        success: '#006044',
        info: '#193ab7',
      },
      spacing: { xs: '4px', sm: '8px', md: '16px', lg: '24px', xl: '32px' },
      fonts: {
        body: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
        heading: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
        mono: "'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, monospace",
      },
      components: {
        borderRadius: '1rem',
        buttonRadius: '2rem',
        cardRadius: '1rem',
        inputRadius: '0.5rem',
        shadowSm: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
        shadowMd: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1)',
        shadowLg: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1)',
        borderWidth: '2px',
      },
    },
    preview: {
      colors: ['#000000', '#370a00', '#fff7ed', '#8c3f27'] as [string, string, string, string],
    },
  },
  {
    id: 'cmyk',
    name: 'Cmyk',
    source: 'daisy' as const,
    mode: 'light' as const,
    theme: {
      mode: 'light' as const,
      colors: {
        primary: '#45aeee',
        primaryText: '#020b13',
        secondary: '#e8488a',
        accent: '#fff234',
        background: '#ffffff',
        surface: '#eeeeee',
        card: '#eeeeee',
        cardText: '#161616',
        text: '#161616',
        textSecondary: '#130207',
        muted: '#1a1a1a',
        mutedText: '#cbcbcb',
        border: '#dedede',
        error: '#e93f33',
        warning: '#ee8134',
        success: '#823290',
        info: '#4ba8c0',
      },
      spacing: { xs: '4px', sm: '8px', md: '16px', lg: '24px', xl: '32px' },
      fonts: {
        body: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
        heading: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
        mono: "'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, monospace",
      },
      components: {
        borderRadius: '1rem',
        buttonRadius: '1rem',
        cardRadius: '1rem',
        inputRadius: '0.5rem',
        shadowSm: 'none',
        shadowMd: 'none',
        shadowLg: 'none',
        borderWidth: '1px',
      },
    },
    preview: {
      colors: ['#45aeee', '#e8488a', '#ffffff', '#fff234'] as [string, string, string, string],
    },
  },
  {
    id: 'coffee',
    name: 'Coffee',
    source: 'daisy' as const,
    mode: 'dark' as const,
    theme: {
      mode: 'dark' as const,
      colors: {
        primary: '#db924c',
        primaryText: '#110802',
        secondary: '#273e3f',
        accent: '#11576d',
        background: '#261b25',
        surface: '#1e151d',
        card: '#1e151d',
        cardText: '#c59f61',
        text: '#c59f61',
        textSecondary: '#d0d5d5',
        muted: '#120c12',
        mutedText: '#c9c7c9',
        border: '#120a11',
        error: '#fc9581',
        warning: '#ffd260',
        success: '#9db787',
        info: '#8ecac1',
      },
      spacing: { xs: '4px', sm: '8px', md: '16px', lg: '24px', xl: '32px' },
      fonts: {
        body: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
        heading: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
        mono: "'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, monospace",
      },
      components: {
        borderRadius: '1rem',
        buttonRadius: '1rem',
        cardRadius: '1rem',
        inputRadius: '0.5rem',
        shadowSm: 'none',
        shadowMd: 'none',
        shadowLg: 'none',
        borderWidth: '1px',
      },
    },
    preview: {
      colors: ['#db924c', '#273e3f', '#261b25', '#11576d'] as [string, string, string, string],
    },
  },
  {
    id: 'corporate',
    name: 'Corporate',
    source: 'daisy' as const,
    mode: 'light' as const,
    theme: {
      mode: 'light' as const,
      colors: {
        primary: '#0082ce',
        primaryText: '#ffffff',
        secondary: '#61738d',
        accent: '#009689',
        background: '#ffffff',
        surface: '#e8e8e8',
        card: '#e8e8e8',
        cardText: '#181a2a',
        text: '#181a2a',
        textSecondary: '#ffffff',
        muted: '#000000',
        mutedText: '#ffffff',
        border: '#d1d1d1',
        error: '#ff6266',
        warning: '#fdc700',
        success: '#00a43b',
        info: '#0090b5',
      },
      spacing: { xs: '4px', sm: '8px', md: '16px', lg: '24px', xl: '32px' },
      fonts: {
        body: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
        heading: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
        mono: "'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, monospace",
      },
      components: {
        borderRadius: '0.25rem',
        buttonRadius: '0.25rem',
        cardRadius: '0.25rem',
        inputRadius: '0.25rem',
        shadowSm: 'none',
        shadowMd: 'none',
        shadowLg: 'none',
        borderWidth: '1px',
      },
    },
    preview: {
      colors: ['#0082ce', '#61738d', '#ffffff', '#009689'] as [string, string, string, string],
    },
  },
  {
    id: 'cupcake',
    name: 'Cupcake',
    source: 'daisy' as const,
    mode: 'light' as const,
    theme: {
      mode: 'light' as const,
      colors: {
        primary: '#44ebd3',
        primaryText: '#005d58',
        secondary: '#f9cbe5',
        accent: '#ffd6a7',
        background: '#faf7f5',
        surface: '#efeae6',
        card: '#efeae6',
        cardText: '#291334',
        text: '#291334',
        textSecondary: '#a0004a',
        muted: '#262629',
        mutedText: '#e4e4e7',
        border: '#e7e2df',
        error: '#fe1c55',
        warning: '#eeaf00',
        success: '#00ba7b',
        info: '#00a4f2',
      },
      spacing: { xs: '4px', sm: '8px', md: '16px', lg: '24px', xl: '32px' },
      fonts: {
        body: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
        heading: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
        mono: "'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, monospace",
      },
      components: {
        borderRadius: '1rem',
        buttonRadius: '1rem',
        cardRadius: '1rem',
        inputRadius: '2rem',
        shadowSm: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
        shadowMd: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1)',
        shadowLg: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1)',
        borderWidth: '2px',
      },
    },
    preview: {
      colors: ['#44ebd3', '#f9cbe5', '#faf7f5', '#ffd6a7'] as [string, string, string, string],
    },
  },
  {
    id: 'cyberpunk',
    name: 'Cyberpunk',
    source: 'daisy' as const,
    mode: 'light' as const,
    theme: {
      mode: 'light' as const,
      colors: {
        primary: '#ff6596',
        primaryText: '#180408',
        secondary: '#00e8ff',
        accent: '#ce74ff',
        background: '#fff248',
        surface: '#f7e83a',
        card: '#f7e83a',
        cardText: '#000000',
        text: '#000000',
        textSecondary: '#001316',
        muted: '#111a3b',
        mutedText: '#fff248',
        border: '#e3d40e',
        error: '#ff5861',
        warning: '#ffbe00',
        success: '#00a96e',
        info: '#00b5ff',
      },
      spacing: { xs: '4px', sm: '8px', md: '16px', lg: '24px', xl: '32px' },
      fonts: {
        body: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
        heading: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
        mono: "'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, monospace",
      },
      components: {
        borderRadius: '0rem',
        buttonRadius: '0rem',
        cardRadius: '0rem',
        inputRadius: '0rem',
        shadowSm: 'none',
        shadowMd: 'none',
        shadowLg: 'none',
        borderWidth: '1px',
      },
    },
    preview: {
      colors: ['#ff6596', '#00e8ff', '#fff248', '#ce74ff'] as [string, string, string, string],
    },
  },
  {
    id: 'dim',
    name: 'Dim',
    source: 'daisy' as const,
    mode: 'dark' as const,
    theme: {
      mode: 'dark' as const,
      colors: {
        primary: '#9fe88d',
        primaryText: '#091307',
        secondary: '#ff7d5d',
        accent: '#c792e9',
        background: '#2a303c',
        surface: '#242933',
        card: '#242933',
        cardText: '#b2ccd6',
        text: '#b2ccd6',
        textSecondary: '#160503',
        muted: '#1c212b',
        mutedText: '#b2ccd6',
        border: '#20252e',
        error: '#ffae9b',
        warning: '#efd057',
        success: '#62efbd',
        info: '#28ebff',
      },
      spacing: { xs: '4px', sm: '8px', md: '16px', lg: '24px', xl: '32px' },
      fonts: {
        body: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
        heading: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
        mono: "'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, monospace",
      },
      components: {
        borderRadius: '1rem',
        buttonRadius: '1rem',
        cardRadius: '1rem',
        inputRadius: '0.5rem',
        shadowSm: 'none',
        shadowMd: 'none',
        shadowLg: 'none',
        borderWidth: '1px',
      },
    },
    preview: {
      colors: ['#9fe88d', '#ff7d5d', '#2a303c', '#c792e9'] as [string, string, string, string],
    },
  },
  {
    id: 'dracula',
    name: 'Dracula',
    source: 'daisy' as const,
    mode: 'dark' as const,
    theme: {
      mode: 'dark' as const,
      colors: {
        primary: '#ff79c6',
        primaryText: '#16050e',
        secondary: '#bd93f9',
        accent: '#ffb86c',
        background: '#282a36',
        surface: '#232530',
        card: '#232530',
        cardText: '#f8f8f3',
        text: '#f8f8f3',
        textSecondary: '#0d0815',
        muted: '#414558',
        mutedText: '#d6d7db',
        border: '#1f202a',
        error: '#ff5555',
        warning: '#f1fa8c',
        success: '#51fa7b',
        info: '#8be9fd',
      },
      spacing: { xs: '4px', sm: '8px', md: '16px', lg: '24px', xl: '32px' },
      fonts: {
        body: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
        heading: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
        mono: "'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, monospace",
      },
      components: {
        borderRadius: '1rem',
        buttonRadius: '1rem',
        cardRadius: '1rem',
        inputRadius: '0.5rem',
        shadowSm: 'none',
        shadowMd: 'none',
        shadowLg: 'none',
        borderWidth: '1px',
      },
    },
    preview: {
      colors: ['#ff79c6', '#bd93f9', '#282a36', '#ffb86c'] as [string, string, string, string],
    },
  },
  {
    id: 'emerald',
    name: 'Emerald',
    source: 'daisy' as const,
    mode: 'light' as const,
    theme: {
      mode: 'light' as const,
      colors: {
        primary: '#66cc8a',
        primaryText: '#223d30',
        secondary: '#377cfb',
        accent: '#f68067',
        background: '#ffffff',
        surface: '#e8e8e8',
        card: '#e8e8e8',
        cardText: '#333c4d',
        text: '#333c4d',
        textSecondary: '#ffffff',
        muted: '#333c4d',
        mutedText: '#f9fafb',
        border: '#d1d1d1',
        error: '#ff5861',
        warning: '#ffbe00',
        success: '#00a96e',
        info: '#00b5ff',
      },
      spacing: { xs: '4px', sm: '8px', md: '16px', lg: '24px', xl: '32px' },
      fonts: {
        body: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
        heading: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
        mono: "'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, monospace",
      },
      components: {
        borderRadius: '1rem',
        buttonRadius: '1rem',
        cardRadius: '1rem',
        inputRadius: '0.5rem',
        shadowSm: 'none',
        shadowMd: 'none',
        shadowLg: 'none',
        borderWidth: '1px',
      },
    },
    preview: {
      colors: ['#66cc8a', '#377cfb', '#ffffff', '#f68067'] as [string, string, string, string],
    },
  },
  {
    id: 'fantasy',
    name: 'Fantasy',
    source: 'daisy' as const,
    mode: 'light' as const,
    theme: {
      mode: 'light' as const,
      colors: {
        primary: '#6d0076',
        primaryText: '#e3cee4',
        secondary: '#0075c2',
        accent: '#ff8600',
        background: '#ffffff',
        surface: '#e8e8e8',
        card: '#e8e8e8',
        cardText: '#1f2937',
        text: '#1f2937',
        textSecondary: '#cfe4f4',
        muted: '#1f2937',
        mutedText: '#cdd0d3',
        border: '#d1d1d1',
        error: '#ff5861',
        warning: '#ffbe00',
        success: '#00a96e',
        info: '#00b5ff',
      },
      spacing: { xs: '4px', sm: '8px', md: '16px', lg: '24px', xl: '32px' },
      fonts: {
        body: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
        heading: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
        mono: "'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, monospace",
      },
      components: {
        borderRadius: '1rem',
        buttonRadius: '1rem',
        cardRadius: '1rem',
        inputRadius: '0.5rem',
        shadowSm: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
        shadowMd: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1)',
        shadowLg: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1)',
        borderWidth: '1px',
      },
    },
    preview: {
      colors: ['#6d0076', '#0075c2', '#ffffff', '#ff8600'] as [string, string, string, string],
    },
  },
  {
    id: 'forest',
    name: 'Forest',
    source: 'daisy' as const,
    mode: 'dark' as const,
    theme: {
      mode: 'dark' as const,
      colors: {
        primary: '#1fb854',
        primaryText: '#000000',
        secondary: '#1eb88e',
        accent: '#1fb8ab',
        background: '#1b1717',
        surface: '#161212',
        card: '#161212',
        cardText: '#cac9c9',
        text: '#cac9c9',
        textSecondary: '#000c07',
        muted: '#19362d',
        mutedText: '#cdd3d1',
        border: '#110d0d',
        error: '#ff5861',
        warning: '#ffbe00',
        success: '#00a96e',
        info: '#00b5ff',
      },
      spacing: { xs: '4px', sm: '8px', md: '16px', lg: '24px', xl: '32px' },
      fonts: {
        body: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
        heading: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
        mono: "'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, monospace",
      },
      components: {
        borderRadius: '1rem',
        buttonRadius: '1rem',
        cardRadius: '1rem',
        inputRadius: '2rem',
        shadowSm: 'none',
        shadowMd: 'none',
        shadowLg: 'none',
        borderWidth: '1px',
      },
    },
    preview: {
      colors: ['#1fb854', '#1eb88e', '#1b1717', '#1fb8ab'] as [string, string, string, string],
    },
  },
  {
    id: 'garden',
    name: 'Garden',
    source: 'daisy' as const,
    mode: 'light' as const,
    theme: {
      mode: 'light' as const,
      colors: {
        primary: '#fe0075',
        primaryText: '#ffffff',
        secondary: '#8e4162',
        accent: '#5c7f67',
        background: '#e9e7e7',
        surface: '#d4d2d2',
        card: '#d4d2d2',
        cardText: '#100f0f',
        text: '#100f0f',
        textSecondary: '#ead7de',
        muted: '#291e00',
        mutedText: '#e9e7e7',
        border: '#bebdbd',
        error: '#ff5861',
        warning: '#ffbe00',
        success: '#00a96e',
        info: '#00b5ff',
      },
      spacing: { xs: '4px', sm: '8px', md: '16px', lg: '24px', xl: '32px' },
      fonts: {
        body: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
        heading: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
        mono: "'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, monospace",
      },
      components: {
        borderRadius: '1rem',
        buttonRadius: '1rem',
        cardRadius: '1rem',
        inputRadius: '0.5rem',
        shadowSm: 'none',
        shadowMd: 'none',
        shadowLg: 'none',
        borderWidth: '1px',
      },
    },
    preview: {
      colors: ['#fe0075', '#8e4162', '#e9e7e7', '#5c7f67'] as [string, string, string, string],
    },
  },
  {
    id: 'halloween',
    name: 'Halloween',
    source: 'daisy' as const,
    mode: 'dark' as const,
    theme: {
      mode: 'dark' as const,
      colors: {
        primary: '#ff8f00',
        primaryText: '#131616',
        secondary: '#7a00c2',
        accent: '#42aa00',
        background: '#1b1816',
        surface: '#0b0908',
        card: '#0b0908',
        cardText: '#cdcdcd',
        text: '#cdcdcd',
        textSecondary: '#e3d4f6',
        muted: '#2f1b05',
        mutedText: '#d2ccc7',
        border: '#000000',
        error: '#f35248',
        warning: '#d97708',
        success: '#18a34a',
        info: '#2563eb',
      },
      spacing: { xs: '4px', sm: '8px', md: '16px', lg: '24px', xl: '32px' },
      fonts: {
        body: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
        heading: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
        mono: "'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, monospace",
      },
      components: {
        borderRadius: '1rem',
        buttonRadius: '1rem',
        cardRadius: '1rem',
        inputRadius: '0.5rem',
        shadowSm: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
        shadowMd: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1)',
        shadowLg: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1)',
        borderWidth: '1px',
      },
    },
    preview: {
      colors: ['#ff8f00', '#7a00c2', '#1b1816', '#42aa00'] as [string, string, string, string],
    },
  },
  {
    id: 'lemonade',
    name: 'Lemonade',
    source: 'daisy' as const,
    mode: 'light' as const,
    theme: {
      mode: 'light' as const,
      colors: {
        primary: '#419400',
        primaryText: '#010800',
        secondary: '#bdc000',
        accent: '#edd000',
        background: '#f8fdef',
        surface: '#e1e6d9',
        card: '#e1e6d9',
        cardText: '#151614',
        text: '#151614',
        textSecondary: '#0d0e00',
        muted: '#343300',
        mutedText: '#d2d3c7',
        border: '#cbcfc3',
        error: '#efc6c2',
        warning: '#d7d3b0',
        success: '#b9dbc6',
        info: '#b1d9e9',
      },
      spacing: { xs: '4px', sm: '8px', md: '16px', lg: '24px', xl: '32px' },
      fonts: {
        body: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
        heading: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
        mono: "'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, monospace",
      },
      components: {
        borderRadius: '1rem',
        buttonRadius: '1rem',
        cardRadius: '1rem',
        inputRadius: '0.5rem',
        shadowSm: 'none',
        shadowMd: 'none',
        shadowLg: 'none',
        borderWidth: '1px',
      },
    },
    preview: {
      colors: ['#419400', '#bdc000', '#f8fdef', '#edd000'] as [string, string, string, string],
    },
  },
  {
    id: 'lofi',
    name: 'Lofi',
    source: 'daisy' as const,
    mode: 'light' as const,
    theme: {
      mode: 'light' as const,
      colors: {
        primary: '#0d0d0d',
        primaryText: '#ffffff',
        secondary: '#1a1919',
        accent: '#262626',
        background: '#ffffff',
        surface: '#f5f5f5',
        card: '#f5f5f5',
        cardText: '#000000',
        text: '#000000',
        textSecondary: '#ffffff',
        muted: '#000000',
        mutedText: '#ffffff',
        border: '#ebebeb',
        error: '#ff9181',
        warning: '#ffce69',
        success: '#69fec3',
        info: '#5fcfdd',
      },
      spacing: { xs: '4px', sm: '8px', md: '16px', lg: '24px', xl: '32px' },
      fonts: {
        body: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
        heading: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
        mono: "'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, monospace",
      },
      components: {
        borderRadius: '0.5rem',
        buttonRadius: '2rem',
        cardRadius: '0.5rem',
        inputRadius: '0.25rem',
        shadowSm: 'none',
        shadowMd: 'none',
        shadowLg: 'none',
        borderWidth: '1px',
      },
    },
    preview: {
      colors: ['#0d0d0d', '#1a1919', '#ffffff', '#262626'] as [string, string, string, string],
    },
  },
  {
    id: 'luxury',
    name: 'Luxury',
    source: 'daisy' as const,
    mode: 'dark' as const,
    theme: {
      mode: 'dark' as const,
      colors: {
        primary: '#ffffff',
        primaryText: '#161616',
        secondary: '#152747',
        accent: '#513448',
        background: '#09090b',
        surface: '#171618',
        card: '#171618',
        cardText: '#dca54d',
        text: '#dca54d',
        textSecondary: '#cbd0d7',
        muted: '#331800',
        mutedText: '#ffe7a4',
        border: '#1e1d1f',
        error: '#ff6f6f',
        warning: '#e2d563',
        success: '#87d03a',
        info: '#67c6ff',
      },
      spacing: { xs: '4px', sm: '8px', md: '16px', lg: '24px', xl: '32px' },
      fonts: {
        body: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
        heading: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
        mono: "'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, monospace",
      },
      components: {
        borderRadius: '1rem',
        buttonRadius: '1rem',
        cardRadius: '1rem',
        inputRadius: '0.5rem',
        shadowSm: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
        shadowMd: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1)',
        shadowLg: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1)',
        borderWidth: '1px',
      },
    },
    preview: {
      colors: ['#ffffff', '#152747', '#09090b', '#513448'] as [string, string, string, string],
    },
  },
  {
    id: 'night',
    name: 'Night',
    source: 'daisy' as const,
    mode: 'dark' as const,
    theme: {
      mode: 'dark' as const,
      colors: {
        primary: '#3abdf7',
        primaryText: '#010d15',
        secondary: '#818cf8',
        accent: '#f471b5',
        background: '#0f172a',
        surface: '#0c1425',
        card: '#0c1425',
        cardText: '#c9cbd0',
        text: '#c9cbd0',
        textSecondary: '#060715',
        muted: '#1e293b',
        mutedText: '#cdd0d4',
        border: '#0a1120',
        error: '#fb7085',
        warning: '#f4bf51',
        success: '#2fd4bf',
        info: '#0ca5e9',
      },
      spacing: { xs: '4px', sm: '8px', md: '16px', lg: '24px', xl: '32px' },
      fonts: {
        body: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
        heading: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
        mono: "'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, monospace",
      },
      components: {
        borderRadius: '1rem',
        buttonRadius: '1rem',
        cardRadius: '1rem',
        inputRadius: '0.5rem',
        shadowSm: 'none',
        shadowMd: 'none',
        shadowLg: 'none',
        borderWidth: '1px',
      },
    },
    preview: {
      colors: ['#3abdf7', '#818cf8', '#0f172a', '#f471b5'] as [string, string, string, string],
    },
  },
  {
    id: 'nord',
    name: 'Nord',
    source: 'daisy' as const,
    mode: 'light' as const,
    theme: {
      mode: 'light' as const,
      colors: {
        primary: '#5e81ac',
        primaryText: '#03060b',
        secondary: '#81a1c1',
        accent: '#88c0d0',
        background: '#eceff4',
        surface: '#e5e9f0',
        card: '#e5e9f0',
        cardText: '#2e3440',
        text: '#2e3440',
        textSecondary: '#06090d',
        muted: '#4c566a',
        mutedText: '#d8dee9',
        border: '#d8dee9',
        error: '#bf616a',
        warning: '#ebcb8b',
        success: '#a3be8d',
        info: '#b48ead',
      },
      spacing: { xs: '4px', sm: '8px', md: '16px', lg: '24px', xl: '32px' },
      fonts: {
        body: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
        heading: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
        mono: "'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, monospace",
      },
      components: {
        borderRadius: '0.5rem',
        buttonRadius: '1rem',
        cardRadius: '0.5rem',
        inputRadius: '0.25rem',
        shadowSm: 'none',
        shadowMd: 'none',
        shadowLg: 'none',
        borderWidth: '1px',
      },
    },
    preview: {
      colors: ['#5e81ac', '#81a1c1', '#eceff4', '#88c0d0'] as [string, string, string, string],
    },
  },
  {
    id: 'pastel',
    name: 'Pastel',
    source: 'daisy' as const,
    mode: 'light' as const,
    theme: {
      mode: 'light' as const,
      colors: {
        primary: '#e9d4ff',
        primaryText: '#8000d9',
        secondary: '#feccd2',
        accent: '#a3f2ce',
        background: '#ffffff',
        surface: '#f9fafb',
        card: '#f9fafb',
        cardText: '#161616',
        text: '#161616',
        textSecondary: '#c50035',
        muted: '#61738d',
        mutedText: '#dfe5ed',
        border: '#e5e6e7',
        error: '#ff9fa0',
        warning: '#ffb667',
        success: '#7af1a7',
        info: '#51e8fb',
      },
      spacing: { xs: '4px', sm: '8px', md: '16px', lg: '24px', xl: '32px' },
      fonts: {
        body: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
        heading: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
        mono: "'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, monospace",
      },
      components: {
        borderRadius: '1rem',
        buttonRadius: '1rem',
        cardRadius: '1rem',
        inputRadius: '2rem',
        shadowSm: 'none',
        shadowMd: 'none',
        shadowLg: 'none',
        borderWidth: '2px',
      },
    },
    preview: {
      colors: ['#e9d4ff', '#feccd2', '#ffffff', '#a3f2ce'] as [string, string, string, string],
    },
  },
  {
    id: 'retro',
    name: 'Retro',
    source: 'daisy' as const,
    mode: 'light' as const,
    theme: {
      mode: 'light' as const,
      colors: {
        primary: '#ff9fa0',
        primaryText: '#801518',
        secondary: '#b7f6cd',
        accent: '#d08700',
        background: '#ece3ca',
        surface: '#e4d8b4',
        card: '#e4d8b4',
        cardText: '#793205',
        text: '#793205',
        textSecondary: '#00642e',
        muted: '#56524c',
        mutedText: '#d4d0ce',
        border: '#dbca9b',
        error: '#ff6266',
        warning: '#f34700',
        success: '#00776f',
        info: '#0082ce',
      },
      spacing: { xs: '4px', sm: '8px', md: '16px', lg: '24px', xl: '32px' },
      fonts: {
        body: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
        heading: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
        mono: "'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, monospace",
      },
      components: {
        borderRadius: '0.5rem',
        buttonRadius: '0.25rem',
        cardRadius: '0.5rem',
        inputRadius: '0.25rem',
        shadowSm: 'none',
        shadowMd: 'none',
        shadowLg: 'none',
        borderWidth: '1px',
      },
    },
    preview: {
      colors: ['#ff9fa0', '#b7f6cd', '#ece3ca', '#d08700'] as [string, string, string, string],
    },
  },
  {
    id: 'silk',
    name: 'Silk',
    source: 'daisy' as const,
    mode: 'light' as const,
    theme: {
      mode: 'light' as const,
      colors: {
        primary: '#1c1c29',
        primaryText: '#e1ff00',
        secondary: '#1c1c29',
        accent: '#1c1c29',
        background: '#f7f5f3',
        surface: '#f3ede9',
        card: '#f3ede9',
        cardText: '#4b4743',
        text: '#4b4743',
        textSecondary: '#ff7700',
        muted: '#161616',
        mutedText: '#c2bdb9',
        border: '#e2ddd9',
        error: '#ff7878',
        warning: '#efc375',
        success: '#afd89e',
        info: '#78c8ff',
      },
      spacing: { xs: '4px', sm: '8px', md: '16px', lg: '24px', xl: '32px' },
      fonts: {
        body: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
        heading: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
        mono: "'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, monospace",
      },
      components: {
        borderRadius: '1rem',
        buttonRadius: '2rem',
        cardRadius: '1rem',
        inputRadius: '0.5rem',
        shadowSm: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
        shadowMd: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1)',
        shadowLg: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1)',
        borderWidth: '2px',
      },
    },
    preview: {
      colors: ['#1c1c29', '#1c1c29', '#f7f5f3', '#1c1c29'] as [string, string, string, string],
    },
  },
  {
    id: 'sunset',
    name: 'Sunset',
    source: 'daisy' as const,
    mode: 'dark' as const,
    theme: {
      mode: 'dark' as const,
      colors: {
        primary: '#ff865b',
        primaryText: '#160603',
        secondary: '#fd6f9c',
        accent: '#b387fa',
        background: '#121c22',
        surface: '#0e171e',
        card: '#0e171e',
        cardText: '#9fb9d0',
        text: '#9fb9d0',
        textSecondary: '#160409',
        muted: '#1b262c',
        mutedText: '#94a0a9',
        border: '#091319',
        error: '#ffbbbd',
        warning: '#f1c892',
        success: '#addfad',
        info: '#89e0eb',
      },
      spacing: { xs: '4px', sm: '8px', md: '16px', lg: '24px', xl: '32px' },
      fonts: {
        body: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
        heading: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
        mono: "'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, monospace",
      },
      components: {
        borderRadius: '1rem',
        buttonRadius: '1rem',
        cardRadius: '1rem',
        inputRadius: '0.5rem',
        shadowSm: 'none',
        shadowMd: 'none',
        shadowLg: 'none',
        borderWidth: '1px',
      },
    },
    preview: {
      colors: ['#ff865b', '#fd6f9c', '#121c22', '#b387fa'] as [string, string, string, string],
    },
  },
  {
    id: 'synthwave',
    name: 'Synthwave',
    source: 'daisy' as const,
    mode: 'dark' as const,
    theme: {
      mode: 'dark' as const,
      colors: {
        primary: '#f861b4',
        primaryText: '#500323',
        secondary: '#71d1fe',
        accent: '#ff8904',
        background: '#09002f',
        surface: '#120b3d',
        card: '#120b3d',
        cardText: '#a1b1ff',
        text: '#a1b1ff',
        textSecondary: '#042e49',
        muted: '#422ad5',
        mutedText: '#c6d2ff',
        border: '#1c184b',
        error: '#ec8c78',
        warning: '#fede1c',
        success: '#00d3bb',
        info: '#00bafe',
      },
      spacing: { xs: '4px', sm: '8px', md: '16px', lg: '24px', xl: '32px' },
      fonts: {
        body: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
        heading: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
        mono: "'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, monospace",
      },
      components: {
        borderRadius: '1rem',
        buttonRadius: '1rem',
        cardRadius: '1rem',
        inputRadius: '0.5rem',
        shadowSm: 'none',
        shadowMd: 'none',
        shadowLg: 'none',
        borderWidth: '1px',
      },
    },
    preview: {
      colors: ['#f861b4', '#71d1fe', '#09002f', '#ff8904'] as [string, string, string, string],
    },
  },
  {
    id: 'valentine',
    name: 'Valentine',
    source: 'daisy' as const,
    mode: 'light' as const,
    theme: {
      mode: 'light' as const,
      colors: {
        primary: '#f43098',
        primaryText: '#ffffff',
        secondary: '#ab44ff',
        accent: '#71d1fe',
        background: '#fcf2f8',
        surface: '#f9e4f0',
        card: '#f9e4f0',
        cardText: '#c5005a',
        text: '#c5005a',
        textSecondary: '#f8f3fd',
        muted: '#830c41',
        mutedText: '#f9cbe5',
        border: '#f9cbe5',
        error: '#f82834',
        warning: '#ff8904',
        success: '#5ce8b3',
        info: '#51e8fb',
      },
      spacing: { xs: '4px', sm: '8px', md: '16px', lg: '24px', xl: '32px' },
      fonts: {
        body: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
        heading: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
        mono: "'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, monospace",
      },
      components: {
        borderRadius: '1rem',
        buttonRadius: '1rem',
        cardRadius: '1rem',
        inputRadius: '2rem',
        shadowSm: 'none',
        shadowMd: 'none',
        shadowLg: 'none',
        borderWidth: '1px',
      },
    },
    preview: {
      colors: ['#f43098', '#ab44ff', '#fcf2f8', '#71d1fe'] as [string, string, string, string],
    },
  },
  {
    id: 'winter',
    name: 'Winter',
    source: 'daisy' as const,
    mode: 'light' as const,
    theme: {
      mode: 'light' as const,
      colors: {
        primary: '#0069ff',
        primaryText: '#cee4ff',
        secondary: '#463aa2',
        accent: '#c148ac',
        background: '#ffffff',
        surface: '#f2f7fe',
        card: '#f2f7fe',
        cardText: '#394e6a',
        text: '#394e6a',
        textSecondary: '#d5d7ee',
        muted: '#021431',
        mutedText: '#c5cbd2',
        border: '#e3e9f4',
        error: '#e58b8b',
        warning: '#efd7bc',
        success: '#81cfd1',
        info: '#94e7fb',
      },
      spacing: { xs: '4px', sm: '8px', md: '16px', lg: '24px', xl: '32px' },
      fonts: {
        body: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
        heading: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
        mono: "'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, monospace",
      },
      components: {
        borderRadius: '1rem',
        buttonRadius: '1rem',
        cardRadius: '1rem',
        inputRadius: '0.5rem',
        shadowSm: 'none',
        shadowMd: 'none',
        shadowLg: 'none',
        borderWidth: '1px',
      },
    },
    preview: {
      colors: ['#0069ff', '#463aa2', '#ffffff', '#c148ac'] as [string, string, string, string],
    },
  },
  {
    id: 'wireframe',
    name: 'Wireframe',
    source: 'daisy' as const,
    mode: 'light' as const,
    theme: {
      mode: 'light' as const,
      colors: {
        primary: '#d4d4d4',
        primaryText: '#242424',
        secondary: '#d4d4d4',
        accent: '#d4d4d4',
        background: '#ffffff',
        surface: '#f5f5f5',
        card: '#f5f5f5',
        cardText: '#161616',
        text: '#161616',
        textSecondary: '#242424',
        muted: '#d4d4d4',
        mutedText: '#242424',
        border: '#ebebeb',
        error: '#9d0410',
        warning: '#963b00',
        success: '#006044',
        info: '#005889',
      },
      spacing: { xs: '4px', sm: '8px', md: '16px', lg: '24px', xl: '32px' },
      fonts: {
        body: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
        heading: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
        mono: "'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, monospace",
      },
      components: {
        borderRadius: '0.25rem',
        buttonRadius: '0rem',
        cardRadius: '0.25rem',
        inputRadius: '0.25rem',
        shadowSm: 'none',
        shadowMd: 'none',
        shadowLg: 'none',
        borderWidth: '1px',
      },
    },
    preview: {
      colors: ['#d4d4d4', '#d4d4d4', '#ffffff', '#d4d4d4'] as [string, string, string, string],
    },
  },
];
